import { render, staticRenderFns } from "./CustomerSendEmailBtn.vue?vue&type=template&id=1a32e7a0&"
import script from "./CustomerSendEmailBtn.vue?vue&type=script&lang=js&"
export * from "./CustomerSendEmailBtn.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSendEmailBtn.vue?vue&type=style&index=0&id=1a32e7a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports